import React, { useState, useEffect, useRef } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import { financialService } from '../utils/api';
import { formatToWords } from '../utils/formatInWords';

function AnnualInvestments() {
  const { state, actions } = useAppContext();
  const [values, setValues] = useState({
    annualInvestments: state.annualInvestments || '',
    sip:               state.sip               || '',
  });

  useEffect(() => {
    setValues({
      annualInvestments: state.annualInvestments || '',
      sip:               state.sip               || '',
    });
  }, [state.annualInvestments, state.sip]);

  const handleChange = (field) => (e) => {
    const raw   = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  // ── Ref always holding latest cashflow fields ────────────────────────────
  const latestRef = useRef(null);
  useEffect(() => {
    latestRef.current = {
      phoneNumber:        state.phoneNumber,
      salary:             state.salary,
      spouseSalary:       state.spouseSalary,
      otherIncome:        state.otherIncome,
      monthlyExpense:     state.monthlyExpense,
      oneTimeYearly:      state.oneTimeYearly,
      annualInvestments:  state.annualInvestments,
      sip:                state.sip,
    };
  }); // no deps — runs after every render

  // Fire submitCashFlow on unmount (user navigates forward or backward)
  useEffect(() => {
    return () => {
      const s = latestRef.current;
      financialService.submitCashFlow(s.phoneNumber, {
        salary:              s.salary,
        spouse_salary:       s.spouseSalary,
        other_income:        s.otherIncome,
        monthly_expense:     s.monthlyExpense,
        one_time_yearly:     s.oneTimeYearly,
        annual_investments:  s.annualInvestments,
        sip:                 s.sip,
      }).catch(err => console.error('submitCashFlow failed:', err));
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Contribution to SIPs & Other Investments (₹{formatToWords(state.annualInvestments + state.sip * 12)})
          </Typography>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Monthly SIPs
          </Typography>
          <TextField
            value={formatNumber(values.sip)}
            onChange={handleChange('sip')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder="monthly SIP"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:   <InputAdornment>/ month</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            All other annual investments
          </Typography>
          <TextField
            value={formatNumber(values.annualInvestments)}
            onChange={handleChange('annualInvestments')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder="annual investments"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:   <InputAdornment>/ year</InputAdornment>,
            }}
          />
        </Box>
      </CardContent>
    </Box>
  );
}

export default AnnualInvestments;